<app-header></app-header>
<div class="container py-5">
  <div class="row justify-content-center">
    <!-- Columna principal del wizard -->
    <div class="col-lg-8 col-12 mb-4">
      <!-- Steps Indicator -->
      <div class="mb-4">
        <app-steps-indicator [currentStep]="currentStep"></app-steps-indicator>
      </div>
      <!-- Aquí irán los pasos del wizard -->
      <div class="wizard-card card p-4 mb-4">
        <ng-container *ngIf="renderCurrentStep() as StepComponent">
          <ng-container *ngComponentOutlet="StepComponent"></ng-container>
        </ng-container>
        
      </div>
      <app-form-navigation
        [currentStep]="currentStep"
        [showComprobante]="showComprobante"
        [allDocumentsSigned]="allDocumentsSigned"
        [aceptacionFinal]="aceptacionFinal"
        (previous)="goToPreviousStep()"
        (next)="goToNextStep()"
        (openModal)="openModal()"
      ></app-form-navigation>
    </div>
    <!-- Columna lateral para la promoción -->
    <div class="col-lg-4 col-12">
      <div class="wizard-sidebar card p-4 text-center">
        <h5 class="mb-3">¡Obtén hasta <span class="text-primary">3 MESES GRATIS</span>!</h5>
        <p class="mb-0">Promoción exclusiva para nuevas aperturas. Consulta condiciones.</p>
      </div>
    </div>
  </div>
</div>

<app-verification-modal
  [isOpen]="showVerificationModal"
  [phoneNumber]="phoneNumber"
  [timer]="verificationTimer"
  [isCodeComplete]="isVerificationCodeComplete"
  (close)="closeVerificationModal()"
  (confirm)="onVerificationConfirm($event)"
  (keyDown)="onVerificationKeyDown($event)"
></app-verification-modal>

<app-document-modal
  [isOpen]="showDocumentModal"
  [documentTitle]="documentTitle"
  [zoomLevel]="zoomLevel"
  (close)="closeDocumentModal()"
  (sign)="onDocumentSign()"
  (zoom)="onZoom($event)"
></app-document-modal>
